import { mapDataCloudfrontURL } from "../map/MapConstants";
import { getZippedGeoJson } from "../map/ZippedGeoJsonReader";
import { Source, Layer } from "react-map-gl";
import { useState, useEffect } from "react";
import { emptyGeojson } from "../riskAssessment/defaultSourceLayer";

export const DeforestationLayer: React.FC<{
  active: boolean;
}> = ({ active }) => {
  const [geoJsonData, setGeoJsonData] = useState<GeoJsonData>(emptyGeojson);

  const getDeforestationMap = async (): Promise<GeoJsonData> => {
    const url = `${mapDataCloudfrontURL}mining/cys_data_defor_bra_gfw_sad/cys_data_defor_bra_gfw_sad_rough.zip`;
    return getZippedGeoJson(url);
  };

  useEffect(() => {
    if (active) {
      getDeforestationMap().then((geoJsonRes: GeoJsonData) => {
        setGeoJsonData(geoJsonRes);
      });
    } else {
      setGeoJsonData(emptyGeojson);
    }
  }, [active]);

  return (
    <Source key="deforestation" id="deforestation-src" type="geojson" data={geoJsonData}>
      <Layer
        type="fill"
        paint={{
          "fill-color": "orange",
          "fill-opacity": 0.8,
        }}
        source="deforestation-src"
        id="deforestation-layer"
      />
    </Source>
  );
};
